export { renderTextarea_unstable as renderTextarea } from '@fluentui/react-textarea';
